// @ts-ignore
import { hostAndChildren } from './domHelpers';

const disableAllMap = new WeakMap();

function eventHandler(event: any) {
  event.preventDefault();
  event.stopImmediatePropagation();
}

export function toggleDisableChildNodes(element: HTMLElement) {
  // @ts-ignore
  if (element.disabled) {
    element.addEventListener('mousedown', eventHandler, { capture: true });
    element.addEventListener('click', eventHandler, { capture: true });
    element.addEventListener('mouseup', eventHandler, { capture: true });
    element.addEventListener('touchstart', eventHandler, { capture: true, passive: true });
    element.addEventListener('touchend', eventHandler, { capture: true, passive: true });
  } else {
    element.removeEventListener('mousedown', eventHandler, { capture: true });
    element.removeEventListener('click', eventHandler, { capture: true });
    element.removeEventListener('mouseup', eventHandler, { capture: true });
    element.removeEventListener('touchstart', eventHandler, { capture: true });
    element.removeEventListener('touchend', eventHandler, { capture: true });
  }

  hostAndChildren(element, ['slot']).forEach(async (node: any) => {
    // @ts-ignore
    if (element.disabled) {
      // Store original values for tabIndex, disabled attribute, aria-disabled.
      disableAllMap.set(node, {
        tabIndex: node.tabIndex,
        disabled: node.getAttribute('disabled'),
        ariaDisabled: node.ariaDisabled,
      });

      // Set tabIndex, disabled, aria-disabled values to make node fully disabled.
      if (node.setTabIndex) {
        await node.setTabIndex(-1);
      } else {
        node.tabIndex = -1;
      }
      node.setAttribute('disabled', '');
      node.ariaDisabled = 'true';
    } else {
      const matchingNode = disableAllMap.get(node);
      if (!matchingNode) return;

      // Restore original values for tabIndex, disabled attribute, aria-disabled.
      const { tabIndex, disabled, ariaDisabled } = matchingNode;
      if (node.setTabIndex) {
        await node.setTabIndex(tabIndex);
      } else {
        node.tabIndex = tabIndex;
      }
      disabled == null || node === element
        ? node.removeAttribute('disabled')
        : node.setAttribute('disabled', disabled);
      node.ariaDisabled = node === element ? false : ariaDisabled;
    }
  });
}
